"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLoader = setLoader;
exports.setImpersonationInput = setImpersonationInput;
exports.setShowImpersonationError = setShowImpersonationError;
function setLoader(loader) {
    return {
        type: "debug/SET-LOADER",
        loader: loader
    };
}
function setImpersonationInput(input) {
    return {
        type: "debug/SET-IMPERSONATION-INPUT",
        input: input
    };
}
function setShowImpersonationError(showError) {
    return {
        type: "debug/SET-IMPERSONATION-ERROR",
        showError: showError
    };
}
//# sourceMappingURL=actions.js.map